import { render, staticRenderFns } from "./viewPayroll.vue?vue&type=template&id=096d68a9&scoped=true&"
import script from "./viewPayroll.vue?vue&type=script&lang=js&"
export * from "./viewPayroll.vue?vue&type=script&lang=js&"
import style0 from "./viewPayroll.vue?vue&type=style&index=0&id=096d68a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d68a9",
  null
  
)

export default component.exports